document.addEventListener('DOMContentLoaded', function () {
    // Find the product form and variant data
    const productForm = document.querySelector('form[data-product-form]');
    const variantDataElement = document.querySelector('[data-variants]');

    if (!productForm || !variantDataElement) {
        console.error('Product form or variants data not found.');
        return;
    }

    let variants;
    try {
        variants = JSON.parse(variantDataElement.textContent);
    } catch (e) {
        console.error('Error parsing variants data:', e);
        return;
    }

    productForm.addEventListener('change', function () {
        const selectedOptions = Array.from(productForm.elements['options[]']).map(option => option.value).join(' / ');

        const selectedVariant = variants.find(variant => variant.title === selectedOptions);

        if (selectedVariant) {
            console.log('Variant selected:', selectedVariant);

            // Update SKU
            const skuElement = document.querySelector('[data-variant-sku]');
            if (skuElement) skuElement.textContent = selectedVariant.sku || 'N/A';

            // Update price
            const priceElement = document.querySelector('[data-variant-price]');
            if (priceElement) priceElement.textContent = Shopify.formatMoney(selectedVariant.price);

            // Update add-to-cart button
            const addToCartButton = productForm.querySelector('[type="submit"]');
            if (addToCartButton) {
                if (!selectedVariant.available) {
                    addToCartButton.disabled = true;
                    addToCartButton.textContent = 'Sold Out';
                } else {
                    addToCartButton.disabled = false;
                    addToCartButton.textContent = 'Add to Cart';
                }
            }

            // Update inventory display
            const inventoryElement = document.querySelector('[data-variant-inventory]');
            if (inventoryElement) {
                inventoryElement.textContent = selectedVariant.inventory_quantity > 0
                    ? `In Stock: ${selectedVariant.inventory_quantity}`
                    : 'Out of Stock';
            }

            // Update variant image
            const productImage = document.querySelector('[data-product-image]');
            if (productImage && selectedVariant.featured_image) {
                productImage.src = selectedVariant.featured_image.src;
            }
        } else {
            console.error('No matching variant found for selected options:', selectedOptions);
        }
    });
});


